import { BaseService } from '../base/BaseService';
export class AiDocumentService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiDocumentService.DEFAULT_SERVICE_PATH,
            basePath: AiDocumentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Index a document that was already uploaded to S3 via File Management.
     * Pass the file reference (fileId, url, fileName) from the FileUploader onComplete callback.
     */
    async indexDocument(request) {
        const response = await this.http.post(this.buildUrl('index'), request);
        if (!response.data)
            throw new Error('No data returned from document indexing');
        return response.data;
    }
    async listDocuments(vendorId = 0) {
        const url = vendorId === 0 ? this.buildUrl('') : this.buildUrl(`vendor/${vendorId}`);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async deleteDocument(documentId, vendorId = 0) {
        const params = vendorId !== 0 ? { vendorId } : {};
        const response = await this.http.delete(this.buildUrlWithParams(`${documentId}`, params));
        return response.data ?? false;
    }
    async askQuestion(request) {
        const response = await this.http.post(this.buildUrl('ask'), request);
        if (!response.data)
            throw new Error('No data returned from document Q&A');
        return response.data;
    }
    /**
     * Staff-portal RAG entry point: ask a question about a single HR policy.
     * The backend resolves the policy's indexed documents by its
     * `hr-policy:{policyId}:` FileReference convention, so callers don't need
     * `AI.Document.Read` permission and don't need to know document IDs.
     *
     * Returns a friendly placeholder response when the policy hasn't been
     * indexed yet — `confidence` will be 0 and `sources` empty — so the chat
     * UI can show a "not indexed" hint without treating it as a hard error.
     */
    async askPolicyQuestion(policyId, question) {
        const response = await this.http.post(this.buildUrl(`policy/${policyId}/ask`), { question });
        if (!response.data)
            throw new Error('No data returned from policy Q&A');
        return response.data;
    }
    /**
     * Ensures a policy is indexed in the RAG store. Idempotent — returns
     * immediately when already cached, or runs the full chunk + embed pipeline
     * (5–15s) on a cold policy. The status field lets the chat panel show
     * distinct UI for "AlreadyIndexed" vs "Indexed" (just done) vs "NoDocument".
     */
    async ensurePolicyIndexed(policyId) {
        const response = await this.http.post(this.buildUrl(`policy/${policyId}/ensure-indexed`), {});
        if (!response.data)
            throw new Error('No data returned from ensure-indexed');
        return response.data;
    }
}
AiDocumentService.DEFAULT_SERVICE_PATH = 'ai-management';
AiDocumentService.BASE_PATH = 'api/ai/documents';
//# sourceMappingURL=AiDocumentService.js.map